// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-wavy{min-width:210px;max-width:225px}.w-wavy .v-image .v-responsive__content{position:relative}.w-wavy .v-image .layout{position:absolute;top:0;left:0;width:100%;height:100%;z-index:10;background:rgba(0,0,0,.452);margin:0!important}.w-wavy__content{padding-left:10px;text-align:left}.w-wavy__content__play{text-transform:none}", ""]);
// Exports
module.exports = exports;
